import Vue from 'vue'
import {
      popup, Button, Tabbar, TabbarItem, Cell, CellGroup, Search, DropdownMenu, DropdownItem,
      NoticeBar, Swipe, SwipeItem, Switch, Calendar, Tab, Tabs, Checkbox, CheckboxGroup, Field,
      ActionSheet, Area, Empty, Dialog, Uploader, Form, SubmitBar, Stepper, RadioGroup, Radio, Icon,
      Step, Steps, Picker, Skeleton, Collapse, CollapseItem, Divider,
      Tag, NumberKeyboard, PasswordInput, Grid, GridItem, DatetimePicker ,
      Loading 

} from 'vant';

Vue.use(DatetimePicker);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(PasswordInput)
Vue.use(NumberKeyboard)
Vue.use(Tag);
Vue.use(Divider);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Skeleton);
Vue.use(Picker);
Vue.use(Step);
Vue.use(Steps);
Vue.use(Icon);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Stepper);
Vue.use(SubmitBar);
Vue.use(Form);
Vue.use(Uploader);
Vue.use(Dialog);
Vue.use(Empty);
Vue.use(Area);
Vue.use(ActionSheet);
Vue.use(Field);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Calendar);
Vue.use(Switch);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(NoticeBar);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Search);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(popup);
Vue.use(Button);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Loading);